import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/grow.ts
function grow(options = {}) {
	return Type.Boolean({
		title: "Auto expand",
		description: "If set, the brick will grow to fill the available space of its parent section or box.",
		"ui:styleId": "styles:grow",
		"ui:responsive": true,
		...options
	});
}

//#endregion
export { grow };
//# sourceMappingURL=grow.js.map